import { Routes } from '@angular/router';
import { Constants } from './common/constants';
import { canActivateLauncher, canActivateLoginPage, canActivatePermission, canActivateSignage } from './services/auth/auth.service';
import { canMatchCurrentDeployment } from './services/deployment-version/deployment-version.service';


const appRoutes: Routes = [
    {
        path: Constants.routingPaths.launcherConfiguration,
        loadComponent: () => import('./pages/launcher/launcher-configuration.component').then(c => c.LauncherConfigurationComponent),
        canActivate: [canActivateSignage, canActivateLauncher, canActivatePermission]
    },
    {
        path: Constants.routingPaths.launcherMenu + '/:id',
        loadComponent: () => import('./pages/launcher/launcher-menu-detail/launcher-menu-detail.component').then(c => c.LauncherMenuDetailComponent),
        canActivate: [canActivateSignage, canActivateLauncher, canActivatePermission]
    },
    {
        path: Constants.routingPaths.launcherDetail + '/:id',
        loadComponent: () => import('./pages/launcher/launcher-detail.component').then(c => c.LauncherDetailComponent),
        canActivate: [canActivateSignage, canActivateLauncher, canActivatePermission]
    },
    {
        path: Constants.routingPaths.launcher + '/:id',
        loadComponent: () => import('./pages/launcher/launcher-detail.component').then(c => c.LauncherDetailComponent),
        canActivate: [canActivateSignage, canActivateLauncher, canActivatePermission]
    },
    {
        path: Constants.routingPaths.launcher,
        loadComponent: () => import('./pages/launcher/launcher.component').then(c => c.LauncherComponent),
        canActivate: [canActivateSignage, canActivateLauncher, canActivatePermission]
    },
    { path: '', redirectTo: Constants.routingPaths.dashboard, pathMatch: 'full' },

    {
        path: Constants.routingPaths.login,
        loadComponent: () => import('./pages/login-register/login/login.component').then((c) => c.LoginComponent),
        canActivate: [canActivateLoginPage]
    },

    {
        path: Constants.routingPaths.register,
        loadComponent: () => import('./pages/login-register/register/register.component').then((c) => c.RegisterComponent),
        canActivate: [canActivateLoginPage]
    },

    {
        path: Constants.routingPaths.resetPassword,
        loadComponent: () => import('./pages/password/forgot-password/forgot-password.component').then((c) => c.ForgotPasswordComponent),
        canActivate: [canActivateLoginPage]
    },

    {
        path: Constants.routingPaths.terms,
        loadComponent: () => import('./pages/terms/terms-page/terms-page.component').then((c) => c.TermsPageComponent)
    },

    {
        path: Constants.routingPaths.privacy,
        loadComponent: () => import('./pages/privacy-policy/privacy-policy-page/privacy-policy-page.component').then((c) => c.PrivacyPolicyPageComponent)
    },

    {
        path: Constants.routingPaths.dashboard,
        loadComponent: () => import('./pages/dashboard/dashboard.component').then((c) => c.DashboardComponent),
        canActivate: [canActivateSignage]
    },

    {
        path: Constants.routingPaths.screeens,
        loadComponent: () => import('./pages/screen/screen.component').then((c) => c.ScreenComponent),
        canActivate: [canActivateSignage, canActivatePermission]
    },

    {
        path: Constants.routingPaths.screeensView + '/:id',
        loadComponent: () => import('./pages/screen/screen-detail/screen-detail.component').then((c) => c.ScreenDetailComponent),
        canActivate: [canActivateSignage, canActivatePermission]
    },

    {
        path: Constants.routingPaths.contents,
        loadComponent: () => import('./pages/contents/contents.component').then((c) => c.ContentsComponent),
        canActivate: [canActivateSignage, canActivatePermission]
    },

    {
        path: Constants.routingPaths.compositions,
        loadComponent: () => import('./pages/composition/composition.component').then((c) => c.CompositionComponent),
        canActivate: [canActivateSignage, canActivatePermission]

    },

    {
        path: Constants.routingPaths.compositionLayout,
        loadComponent: () => import('./pages/composition/composition-layout/composition-layout.component').then((c) => c.CompositionLayoutComponent),
        canActivate: [canActivateSignage, canActivatePermission]

    },

    {
        path: Constants.routingPaths.compositions + '/:id',
        loadComponent: () => import('./pages/composition/composition-detail/composition-detail.component').then((c) => c.CompositionDetailComponent),
        canActivate: [canActivateSignage, canActivatePermission]

    },

    {
        path: Constants.routingPaths.customLayout,
        loadComponent: () => import('./pages/composition/custom-layout-wrapper/custom-layout-wrapper.component').then((c) => c.CustomLayoutWrapperComponent),
        canActivate: [canActivateSignage, canActivatePermission]

    },

    {
        path: Constants.routingPaths.broadcasts,
        loadComponent: () => import('./pages/broadcast/broadcast.component').then((c) => c.BroadcastComponent),
        canActivate: [canActivateSignage, canActivatePermission]

    },

    {
        path: Constants.routingPaths.createBroadcast,
        loadComponent: () => import('./pages/broadcast/create-broadcast/create-broadcast.component').then((c) => c.CreateBroadcastComponent),
        canActivate: [canActivateSignage, canActivatePermission]
    },

    {
        path: Constants.routingPaths.updateBroadcast + '/:id',
        loadComponent: () => import('./pages/broadcast/create-broadcast/create-broadcast.component').then((c) => c.CreateBroadcastComponent),
        canActivate: [canActivateSignage, canActivatePermission]
    },

    {
        path: Constants.routingPaths.plannedBroadcast + '/:id',
        loadComponent: () => import('./pages/broadcast/broadcast-detail/broadcast-detail.component').then((c) => c.BroadcastDetailComponent),
        canActivate: [canActivateSignage, canActivatePermission]

    },

    {
        path: Constants.routingPaths.accountInfo,
        loadComponent: () => import('./pages/account-info/account-info.component').then((c) => c.AccountInfoComponent),
        canActivate: [canActivateSignage]

    },

    {
        path: Constants.routingPaths.settings,
        loadComponent: () => import('./pages/settings/settings.component').then((c) => c.SettingsComponent),
        canActivate: [canActivateSignage, canActivatePermission]

    },

    {
        path: Constants.routingPaths.apps,
        loadComponent: () => import('./pages/apps/apps-list.component').then((c) => c.AppsListComponent),
        canActivate: [canActivateSignage, canActivatePermission]
    },

    {
        path: Constants.routingPaths.appDigitalClock,
        loadComponent: () => import('./pages/apps/defaults-apps/digital-clock/digital-clock.component').then((c) => c.DigitalClockComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appDigitalClock + '/:id',
        loadComponent: () => import('./pages/apps/defaults-apps/digital-clock/digital-clock.component').then((c) => c.DigitalClockComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appAnalogueClock,
        loadComponent: () => import('./pages/apps/defaults-apps/analogue-clock/analogue-clock.component').then((c) => c.AnalogueClockComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appAnalogueClock + '/:id',
        loadComponent: () => import('./pages/apps/defaults-apps/analogue-clock/analogue-clock.component').then((c) => c.AnalogueClockComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appWeather,
        loadComponent: () => import('./pages/apps/defaults-apps/weather-app/weather-app.component').then((c) => c.WeatherAppComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appWeather + '/:id',
        loadComponent: () => import('./pages/apps/defaults-apps/weather-app/weather-app.component').then((c) => c.WeatherAppComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appCountdownTimer,
        loadComponent: () => import('./pages/apps/defaults-apps/countdown-timer/countdown-timer.component').then((c) => c.CountdownTimerComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appCountdownTimer + '/:id',
        loadComponent: () => import('./pages/apps/defaults-apps/countdown-timer/countdown-timer.component').then((c) => c.CountdownTimerComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appCalendar,
        loadComponent: () => import('./pages/apps/defaults-apps/calendar-app/calendar-app.component').then((c) => c.CalendarAppComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appCalendar + '/:id',
        loadComponent: () => import('./pages/apps/defaults-apps/calendar-app/calendar-app.component').then((c) => c.CalendarAppComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appQrCode,
        loadComponent: () => import('./pages/apps/defaults-apps/qr-code-app/qr-code-app.component').then((c) => c.QrCodeAppComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appQrCode + '/:id',
        loadComponent: () => import('./pages/apps/defaults-apps/qr-code-app/qr-code-app.component').then((c) => c.QrCodeAppComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appYoutube,
        loadComponent: () => import('./pages/apps/defaults-apps/youtube-app/youtube-app.component').then((c) => c.YoutubeAppComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appYoutube + '/:id',
        loadComponent: () => import('./pages/apps/defaults-apps/youtube-app/youtube-app.component').then((c) => c.YoutubeAppComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appNotepad,
        loadComponent: () => import('./pages/apps/defaults-apps/notepad-app/notepad-app.component').then((c) => c.NotepadAppComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appNotepad + '/:id',
        loadComponent: () => import('./pages/apps/defaults-apps/notepad-app/notepad-app.component').then((c) => c.NotepadAppComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appScrollText,
        loadComponent: () => import('./pages/apps/defaults-apps/scroll-text/scroll-text.component').then((c) => c.ScrollTextComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appScrollText + '/:id',
        loadComponent: () => import('./pages/apps/defaults-apps/scroll-text/scroll-text.component').then((c) => c.ScrollTextComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appWebsitePreview,
        loadComponent: () => import('./pages/apps/defaults-apps/website-preview-app/website-preview-app.component').then((c) => c.WebsitePreviewAppComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appWebsitePreview + '/:id',
        loadComponent: () => import('./pages/apps/defaults-apps/website-preview-app/website-preview-app.component').then((c) => c.WebsitePreviewAppComponent),
        canActivate: [canActivateSignage, canActivatePermission],
    },

    {
        path: Constants.routingPaths.appsSelect,
        loadComponent: () => import('./pages/apps/select-app/select-app.component').then((c) => c.SelectAppComponent),
        canActivate: [canActivateSignage, canActivatePermission]

    },

    {
        path: Constants.routingPaths.appsAdd + '/:id',
        loadComponent: () => import('./pages/apps/add-app/add-app.component').then((c) => c.AddAppComponent),
        canActivate: [canActivateSignage, canActivatePermission]

    },

    {
        path: Constants.routingPaths.appsEdit + '/:app_id',
        loadComponent: () => import('./pages/apps/add-app/add-app.component').then((c) => c.AddAppComponent),
        canActivate: [canActivateSignage, canActivatePermission]

    },

    {
        path: Constants.routingPaths.dzynflix,
        loadComponent: () => import('./pages/dzynflix/dzynflix.component').then((c) => c.DzynflixComponent),
        canActivate: [canActivateSignage, canActivatePermission]

    },

    {
        path: Constants.routingPaths.templates,
        loadComponent: () => import('./pages/templates/template-container/template-container.component').then((c) => c.TemplateContainerComponent),
        canActivate: [canActivateSignage, canActivatePermission]

    },

    {
        path: Constants.routingPaths.reports,
        loadComponent: () => import('./pages/reports/reports.component').then((c) => c.ReportsComponent),
        canActivate: [canActivateSignage, canActivatePermission]

    },

    {
        path: Constants.routingPaths.accessDenied,
        loadComponent: () => import('./shared/access-denied/access-denied.component').then((c) => c.AccessDeniedComponent),
        canActivate: [canActivateSignage]

    },

    {
        path: 'impersonate_user',
        loadComponent: () => import('./shared/token-handler/token-handler.component').then((c) => c.TokenHandlerComponent),
    },

    {
        path: '**',
        loadComponent: () => import('./shared/page-not-found/page-not-found.component').then((c) => c.PageNotFoundComponent),
        canActivate: [canActivateLoginPage]

    }

];

export const routes: Routes = appRoutes.map((route) => {
    if (!route.loadComponent) return route;
    return {
        ...route,
        canMatch: [...(route.canMatch ?? []), canMatchCurrentDeployment]
    };
});
